import React, { useEffect, useState } from "react";
import Link from "next/link";
import { getInitialData } from "../service/apiFetch";
import { getQuizAll } from "../service/apiFetch";
import { SkeletonBlock } from "../components/utils/Skeleton";
import WsrvImage from "../components/utils/WsrvImage";
import { getWsrvUrl } from "../utils/wsrv";

export const getStaticProps = async () => {
  const initialData = await getInitialData("mock-test", {
    contentBlock: "Object",
  });
  return {
    props: {
      websiteData: initialData?.websiteData || "",
      data: initialData?.data || "",
      title: initialData?.title || "",
      metaTags: initialData?.metaTags || "",
      error: initialData?.error || "",
    },
  };
};

export default function MockTest() {
  const [allQuiz, setAllQuiz] = useState([]);
  const [loading, setLoading] = useState(true); // NEW

  const fetchQuiz = async () => {
    try {
      const response = await getQuizAll();
      setAllQuiz(response);
    } catch (error) {
      console.error("Error fetching quiz data:", error);
    } finally {
      setLoading(false); // Done loading
    }
  };

  useEffect(() => {
    fetchQuiz();
  }, []);

  return (
    <>
      <section className="min-h-[450px]">
        <div className="heading bg-color my-4">
          <h2 className="text-center text-2xl font-semibold py-1">
            Select your Passion
          </h2>
        </div>

        {loading ? (
          <div className="container">
            <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4 lg:py-16 py-8">
              {[1,2,3].map(i => (
                <div key={i} className="animate-pulse shadow-md rounded-md bg-white p-10">
                  <SkeletonBlock className="h-48 rounded-lg mb-4" />
                  <SkeletonBlock className="h-6 w-2/3 mx-auto" />
                </div>
              ))}
            </div>
          </div>
        ) : allQuiz?.length > 0 ? (
          <div className="container ">
            <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4 lg:py-16 py-8">
              {allQuiz.map((item, ind) => (
                <Link
                  href={`/mock-test/${item.id}`}
                  className="block"
                  key={ind}
                >
                  <div
                    className="shadow-md bg-no-repeat bg-contain bg-right-bottom p-10 rounded-md bg-white transition-transform duration-300 hover:scale-90"
                    style={{
                      backgroundImage: `url('${getWsrvUrl(
                        "https://i.filecdn.in/807clcworld/clca-1725359903830.png",
                        { w: 400, q: 80 }
                      )}')`,
                    }}
                  >
                    <h3 className="text-lg font-semibold text-center">
                      {item.title}
                    </h3>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
            <WsrvImage
              src="https://i.filecdn.in/807clcworld/notfoundquiezzesicon-1756963144456.png"
              alt="No quizzes"
              width={128}
              height={128}
              widths={[128, 256]}
              className="w-32 h-32 mb-6 opacity-80"
            />
            <h3 className="text-2xl font-semibold text-gray-700 mb-2">
              No Quizzes Available
            </h3>
            <p className="text-gray-500 max-w-md mb-6">
              Looks like there are no quizzes right now. Check back later or
              explore other categories to keep learning!
            </p>
            <Link href="/" className="my-button cursor-pointer">
              Go to Home Page
            </Link>
          </div>
        )}
      </section>
    </>
  );
}
